import { useMemo } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from 'yup';
import "react-phone-input-2/lib/bootstrap.css";
import { FormikProvider, useFormik } from "formik";
import { useDispatch } from "react-redux";
import { CONFIRM_ALERT } from "common/constantMessage";


export default function RestoreConfirmationPopup({ showPopup, closePopup, currentItem, handleRestore }) {
	const dispatch = useDispatch();

	const validationSchema = useMemo(() => {
		return Yup.object().shape({
			confirmation: Yup.string()
				// .transform((value) => value?.toLowerCase())
				.required(`To confirm, please type "RESTORE".`)
				.oneOf(["RESTORE"], "Please type the correct phrase to proceed."),
		});
	}, []);
	
	const formik = useFormik({
		initialValues: {
			confirmation: ""
		},
		validationSchema: validationSchema,
		onSubmit: async (values, { setSubmitting }) => {
			try {
				const isConfirm = await CONFIRM_ALERT();
				if(!isConfirm) {
				return;
				}
		
				const result = await handleRestore({ id: currentItem.id });
				
				console.log("result", result);
	
				setSubmitting(true)
				handleClose();
			} catch (error) {
				console.log(error)
			} finally {
				setSubmitting(false);
			}
		},
		enableReinitialize: true,
	})

	const handleClose = () => {
		formik.resetForm();
		closePopup();
	}

	return (
		<>
			<Modal
				show={showPopup}
				onHide={handleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>Restore Item</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormikProvider
						value={formik}
					>
						<Form onSubmit={formik.handleSubmit} autoComplete="off">
							<Row>
								<Col lg="12" className="my-2">
									<label htmlFor="" className="form-label m-0 fw-sbold">
										Please confirm by typing "RESTORE"
									</label>
									<input
										type="text"
										className={`form-control ${formik.errors.confirmation && "is-invalid"}`}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										name="confirmation"
										value={formik.values.confirmation}
									/>
									{formik.errors.confirmation && formik.touched.confirmation && (
										<p className="invalid-feedback">{formik.errors.confirmation}</p>
									)}
								</Col>
								<Col lg="12">
									<Modal.Footer>
										<Button variant="secondary"
											onClick={handleClose}
										>
											Close
										</Button>
										<Button
											variant="primary"
											type="submit"
											disabled={formik.isSubmitting || !formik.isValid}
										>
											{formik.isSubmitting ? 'Please Wait...' : 'Confirm'}
										</Button>
									</Modal.Footer>
								</Col>
							</Row>
						</Form>
					</FormikProvider>
				</Modal.Body>
				</Modal>
		</>
	);
}